import { Card, Modal, Row } from 'ant-design-vue';
import { h } from 'vue';

export default (
  title: string,
  card_title: string,
  columns: Array<any>,
  datasource: Array<any>,
  card_title2 = '',
  columns2: Array<any> = [],
  datasource2: Array<any> = [],
) => {
  let width = 0;
  columns.map(item => {
    if (!item.width) {
      item.width = 50;
    }
    width += item.width;
  });
  const children: any = [];
  for (const k of columns) {
    children.push(
      h(
        Card.Grid,
        {
          style: {
            width: k.width + 'px',
            overflow: 'hidden',
            'text-overflow': 'ellipsis',
            'white-space': 'nowrap',
            'text-align': 'center',
            padding: '10px',
          },
        },
        k.title,
      ),
    );
  }
  let index = 1;
  for (const item of datasource) {
    for (const k of columns) {
      if (k.dataIndex == 'index') {
        children.push(
          h(
            Card.Grid,
            {
              style: {
                width: k.width + 'px',
                overflow: 'hidden',
                'text-overflow': 'ellipsis',
                'white-space': 'nowrap',
                'text-align': 'center',
                padding: '10px',
              },
            },
            index,
          ),
        );
      } else {
        children.push(
          h(
            Card.Grid,
            {
              title: item[k.dataIndex],
              style: {
                width: k.width + 'px',
                overflow: 'hidden',
                'text-overflow': 'ellipsis',
                'white-space': 'nowrap',
                'text-align': 'center',
                padding: '10px',
              },
            },
            item[k.dataIndex],
          ),
        );
      }
    }
    index += 1;
  }

  let width2 = 0;
  columns2.map(item => {
    if (!item.width) {
      item.width = 50;
    }
    width2 += item.width;
  });
  const children2: any = [];
  for (const k of columns2) {
    children2.push(
      h(
        Card.Grid,
        {
          style: {
            width: k.width + 'px',
            overflow: 'hidden',
            'text-overflow': 'ellipsis',
            'white-space': 'nowrap',
            'text-align': 'center',
            padding: '10px',
          },
        },
        k.title,
      ),
    );
  }
  let index2 = 1;
  for (const item of datasource2) {
    for (const k of columns2) {
      if (k.dataIndex == 'index') {
        children2.push(
          h(
            Card.Grid,
            {
              style: {
                width: k.width + 'px',
                overflow: 'hidden',
                'text-overflow': 'ellipsis',
                'white-space': 'nowrap',
                'text-align': 'center',
                padding: '10px',
              },
            },
            index2,
          ),
        );
      } else {
        children2.push(
          h(
            Card.Grid,
            {
              title: item[k.dataIndex],
              style: {
                width: k.width + 'px',
                overflow: 'hidden',
                'text-overflow': 'ellipsis',
                'white-space': 'nowrap',
                'text-align': 'center',
                padding: '10px',
              },
            },
            item[k.dataIndex],
          ),
        );
      }
    }
    index2 += 1;
  }

  const clist = [];
  if (datasource.length > 0) {
    clist.push(h(Card, { title: card_title, size: 'small' }, children));
  }
  if (datasource2.length > 0) {
    clist.push(h(Card, { title: card_title2, size: 'small' }, children2));
  }

  Modal.info({
    title: title,
    width: (width > width2 ? width : width2) + 103,
    content: h('div', clist),
    onOk() {
      console.log('ok');
    },
  });
};
